module.exports = __webpack_public_path__ + "2e8d8dd7abe73dadab972859de8dc23a.jpg";